import type { ReactNode } from "react"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"

export default function DetailRow({
    label,
    children,
    growChildrenContainer,
    wider,
}: {
    label: string,
    children?: ReactNode,
    growChildrenContainer?: boolean,
    wider?: boolean,
}) {

    return (
        <Box sx={{
            display: 'flex',
            gap: 1,
        }}>
            <Box sx={{
                flexBasis: wider ? '40%' : '30%',
                flexShrink: 0,
            }}>
                <Typography variant="h6" component="div">
                    {label}
                </Typography>
            </Box>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                ...(growChildrenContainer ? { flexGrow: 1 } : {}),
            }}>
                {children}
            </Box>
        </Box>
    )
}
